export * from './collaborations.interface';
export * from './offices-scopen.interface';
export * from './primeng-scopen.interface';
export * from './professionals-scopen.interface';
export * from './scopen-api.interface';
